import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from 'emailjs-com';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/common.css";
import "../styles/form.css";

const Contact = () => {
  const navigate = useNavigate();
  const form = useRef();

  const [formData, setFormData] = useState({
    inquiryType: '',
    company: '',
    name: '',
    email: '',
    message: '',
    privacy: false,
  });

  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    message: ''
  });

  const [successModal, setSuccessModal] = useState({
    isOpen: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 環境変数のチェック
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      console.error('EmailJS環境変数が設定されていません:', {
        serviceId: !!serviceId,
        templateId: !!templateId,
        publicKey: !!publicKey
      });
      setErrorModal({
        isOpen: true,
        message: 'メール送信の設定が完了していません。管理者にお問い合わせください。'
      });
      return;
    }

    // フォームデータの確認（デバッグ用）
    console.log('送信するフォームデータ:', formData);
    console.log('フォーム要素:', form.current);

    emailjs.sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
        console.log('EmailJS送信成功:', result);
        console.log('送信結果:', result.text);
        // フォームをリセット
        setFormData({
          inquiryType: '',
          company: '',
          name: '',
          email: '',
          message: '',
          privacy: false,
        });
        // 成功モーダルを表示
        setSuccessModal({ isOpen: true });
      }, (error) => {
        console.error('EmailJS送信エラー:', error);
        console.error('エラー詳細:', {
          status: error.status,
          text: error.text,
          message: error.message
        });
        const errorMessage = error.text || error.message || '不明なエラー';
        setErrorModal({
          isOpen: true,
          message: `メール送信に失敗しました。\n\nエラー: ${errorMessage}\n\nもう一度お試しいただくか、管理者にお問い合わせください。`
        });
      });
  };

  const closeErrorModal = () => {
    setErrorModal({ isOpen: false, message: '' });
  };

  const closeSuccessModal = () => {
    setSuccessModal({ isOpen: false });
    navigate('/');
  };

  return (
    <>
      <Navbar />
      {errorModal.isOpen && (
        <div className="error-modal-overlay" onClick={closeErrorModal}>
          <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="error-modal-header">
              <h2>エラー</h2>
              <button className="error-modal-close" onClick={closeErrorModal} aria-label="閉じる">
                ×
              </button>
            </div>
            <div className="error-modal-body">
              <p>{errorModal.message}</p>
            </div>
            <div className="error-modal-footer">
              <button className="button-black button-arrow" onClick={closeErrorModal}>
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
      {successModal.isOpen && (
        <div className="error-modal-overlay" onClick={closeSuccessModal}>
          <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="error-modal-header">
              <h2>送信完了</h2>
              <button className="error-modal-close" onClick={closeSuccessModal} aria-label="閉じる">
                ×
              </button>
            </div>
            <div className="error-modal-body">
              <p>お問い合わせありがとうございます。<br />この度は弊社ホームページをご利用いただきまして、誠にありがとうございます。<br />お問い合わせいただきました内容を確認後、担当者より改めてご連絡いたします。</p>
            </div>
            <div className="error-modal-footer">
              <button className="button-black button-arrow" onClick={closeSuccessModal}>
                ホームに戻る
              </button>
            </div>
          </div>
        </div>
      )}
      <main className='contact'>
        <section className='contact form'>
          <h1>お問い合わせ</h1>
          <p className='form-lead'>相談は無料です。<br />Webサイト制作に関するご相談はもちろん、仕様がまだ固まっていない段階でもお気軽にお問い合わせください。<br />さらに、オリジナルユニフォームやノベルティグッズなど、プリント事業に関するご相談もこちらからどうぞ。</p>
          <div className='form-content'>
            <p className='form-explan'><span className='required'>*</span>がついている項目は必須項目です。必須項目をご入力の上、送信ボタンを押してください。</p>
            <form ref={form} action='#' method='POST' id='contact-form' onSubmit={handleSubmit}>
              <div className='form-box'>
                <label htmlFor="inquiryType">ご相談内容<span className='required'>*</span></label>
                <select
                  id="inquiryType"
                  name="inquiryType"
                  required
                  onChange={handleChange}
                  value={formData.inquiryType}
                >
                  <option value="">選択してください</option>
                  <option value="ユニフォーム・オリジナルプリントなど">ユニフォーム・オリジナルプリントなど</option>
                  <option value="Webサイト制作">Webサイト制作</option>
                  <option value="マーケティング支援">マーケティング支援</option>
                  <option value="ブランディング・越境支援">ブランディング・越境支援</option>
                  <option value="その他">その他</option>
                </select>
              </div>
              <div className='form-box'>
                <label>会社名</label>
                <input
                  type='text'
                  name='company'
                  placeholder='例：株式会社〇〇'
                  onChange={handleChange}
                  value={formData.company}
                />
              </div>
              <div className='form-box'>
                <label>お名前<span className='required'>*</span></label>
                <input type='text' name='name' placeholder='例：山田 太郎' required aria-required='true' onChange={handleChange} value={formData.name}
                />
              </div>
              <div className='form-box'>
                <label>メールアドレス<span className='required'>*</span></label>
                <input
                  type='email'
                  name='email'
                  placeholder='例: example@example.com'
                  required
                  aria-required='true'
                  onChange={handleChange}
                  value={formData.email}
                />
              </div>
              <div className='form-box'>
                <label>お問い合わせ内容<span className='required'>*</span></label>
                <textarea
                  name='message'
                  placeholder='お問い合わせ内容をご記入ください'
                  required
                  aria-required='true'
                  onChange={handleChange}
                  value={formData.message}
                ></textarea>
              </div>
              <div className='privacy-policy'>
                <label>
                  <input
                    type='checkbox'
                    name='privacy'
                    required
                    aria-required='true'
                    onChange={handleChange}
                    checked={formData.privacy}
                  />
                  <span className='privacy-policy__text'>
                    <a href="/datenschutzerklarung" className='button-underLine'>プライバシーポリシー</a>に同意の上、送信します<span className='required'>*</span>
                  </span>
                </label>
              </div>
              <div className='button-black button-arrow button-formSend'>
                <button type='submit' >送信する</button>
              </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Contact;
